export function initAuditLogFilter() {
  const startPicker = document.querySelector<HTMLInputElement>('#audit-log-start-picker');
  const endPicker = document.querySelector<HTMLInputElement>('#audit-log-end-picker');
  if (!startPicker || !endPicker) return;

  const startUnix = document.querySelector<HTMLInputElement>('#audit-log-start-unix');
  const endUnix = document.querySelector<HTMLInputElement>('#audit-log-end-unix');

  startPicker.addEventListener('change', () => {
    const val = startPicker.value;
    const unix = new Date(val).getTime() / 1000;
    startUnix!.value = unix.toString();
  });
  endPicker.addEventListener('change', () => {
    const val = endPicker.value;
    const unix = new Date(val).getTime() / 1000;
    endUnix!.value = unix.toString();
  });
}
